module.exports = __webpack_public_path__ + "media/images/lp-main-girl-cafdd7543d4d1e8cbe7ce19b1786cc6c.jpg";